import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ClienteEditComponent } from '../cliente-edit/cliente-edit.component';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { ClienteDireccion } from 'src/app/Models/cliente/clientedireccion/cliente-direccion';
import { Title } from '@angular/platform-browser';
import { TipoDocumento } from 'src/app/Models/tipodocumento/tipo-documento';

@Component({
  selector: 'app-cliente-index',
  templateUrl: './cliente-index.component.html',
  styleUrls: ['./cliente-index.component.css']
})
export class ClienteIndexComponent implements OnInit {
  @ViewChild(LoadingComponent, null) public loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(AlertComponent, null) public alert: AlertComponent;
  @ViewChild(ClienteEditComponent, null) public fmclienteedit: ClienteEditComponent;
  public cliente: Cliente = new Cliente();
  public clientes: Cliente[] = [];
  public total: number = 0;
  public pgcliente: any;
  public busqueda: string = '';
  public tipodocumentos: TipoDocumento[] = [];

  public tiposclientes: any[] = [];
  public tiposClientes: any[] = [];
  public tipoClienteSeleccionado: string = '';
  public conteoPorTipo: any[] = [];

  public search = { top: 10, clase: 0, subclase: 0, subgrupo: 0, nombre: '', codigo: '', opcion: 'nombre', scale: 'DESC', fechaprogd: this.data.DateNowCurrent(), fechaprogh: this.data.DateNowCurrent(), text: "" }
  constructor(private title: Title, private data: DataService, private notify: NotifyService) {
    this.getTipoDocumento();
  }

  ngOnInit() {
    this.title.setTitle('Clientes | Sistema de ventas');
    this.GetCliente();
    this.GetTiposCliente();

  }

  GetCliente1() {
    this.loading.show('cargando datos');
    this.clientes = [];

    this.data.GetSimple(this.data.api.cliente).subscribe(r => {
      this.loading.hide();
      if (this.data.Exists(r)) {
        console.log(r);

        this.clientes = r;
        this.total = this.clientes.length;
      } else { this.clientes = []; this.total = 0; }
    }, e => { console.log(e.error.text) });
  }

  GetCliente2() {
    this.loading.show('cargando datos');
    this.clientes = [];

    // Construir URL con parámetros de filtro
    let url = this.data.api.cliente;
    const params: string[] = [];

    if (this.tipoClienteSeleccionado) {
      params.push(`tipo_cliente=${this.tipoClienteSeleccionado}`);
    }

    if (this.busqueda) {
      params.push(`search=${encodeURIComponent(this.busqueda)}`);
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    this.data.GetSimple(url).subscribe(
      r => {
        this.loading.hide();

        if (r && r.clientes) {
          // Respuesta nueva del backend con estructura mejorada
          this.clientes = r.clientes;
          this.total = r.total;
          this.conteoPorTipo = r.conteo_por_tipo || [];
        } else if (this.data.Exists(r)) {
          // Respuesta antigua (compatibilidad)
          this.clientes = r;
          this.total = this.clientes.length;
        } else {
          this.clientes = [];
          this.total = 0;
        }

        console.log('Clientes cargados:', this.clientes);
        console.log('Conteo por tipo:', this.conteoPorTipo);
      },
      e => {
        console.error(e);
        this.loading.hide();
        this.clientes = [];
        this.total = 0;
      }
    );
  }

  GetCliente() {
    this.loading.show('cargando datos');
    this.clientes = [];

    // Construir URL con parámetros de filtro
    let url = this.data.api.cliente;
    const params: string[] = [];

    // ✅ CORREGIDO: Manejar correctamente el filtro de tipo de cliente
    if (this.tipoClienteSeleccionado) {
      if (this.tipoClienteSeleccionado === 'null') {
        // Filtrar por clientes SIN tipo
        params.push(`sin_tipo=true`);
      } else {
        // Filtrar por tipo específico
        params.push(`tipo_cliente=${this.tipoClienteSeleccionado}`);
      }
    }
    // Si tipoClienteSeleccionado es vacío, no agregamos ningún parámetro = TODOS

    if (this.busqueda) {
      params.push(`search=${encodeURIComponent(this.busqueda)}`);
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    console.log('🔍 URL de consulta:', url);

    this.data.GetSimple(url).subscribe(
      r => {
        this.loading.hide();

        if (r && r.clientes) {
          // Respuesta nueva del backend con estructura mejorada
          this.clientes = r.clientes;
          this.total = r.total;
          this.conteoPorTipo = r.conteo_por_tipo || [];
          
          console.log('✅ Clientes cargados:', this.clientes.length);
          console.log('📊 Conteo por tipo:', this.conteoPorTipo);
        } else if (this.data.Exists(r)) {
          // Respuesta antigua (compatibilidad)
          this.clientes = r;
          this.total = this.clientes.length;
        } else {
          this.clientes = [];
          this.total = 0;
        }
      },
      e => {
        console.error('❌ Error al cargar clientes:', e);
        this.loading.hide();
        this.clientes = [];
        this.total = 0;
      }
    );
  }

  // ✅ NUEVO: Filtrar por tipo de cliente
  filtrarPorTipo() {
    console.log('Filtrando por tipo:', this.tipoClienteSeleccionado);
    this.GetCliente();
  }

  // ✅ NUEVO: Limpiar filtros
  limpiarFiltros() {
    this.tipoClienteSeleccionado = '';
    this.busqueda = '';
    this.pgcliente = 1;
    this.GetCliente();
  }

  busquedaClientes() {
    this.loading.show('cargando datos');
    this.clientes = [];

    this.data.GetFromValue(this.data.api.cliente, 'like', this.busqueda).subscribe(r => {
      this.loading.hide();
      if (this.data.Exists(r)) {
        this.clientes = r;
        this.total = this.clientes.length;
      } else { this.clientes = []; this.total = 0; }
    }, e => { console.log(e.error.text) });
  }

  searchCliente() {
    this.pgcliente = 1; // Resetear a la primera página
    if (this.busqueda != '') {
      this.GetCliente(); // ✅ Usar GetCliente() en lugar de busquedaClientes() para mantener el filtro de tipo
    } else {
      this.GetCliente();
    }
  }

  getTipoDocumento() {
    this.data.GetSimple(this.data.api.tipodocumento).subscribe(r => {
      try {
        this.tipodocumentos = r;
        console.log(this.tipodocumentos);
      } catch (ex) { console.log(ex); }
    });
  }


  ShowNewCliente() {
    this.fmclienteedit.cliente = new Cliente();
    this.fmclienteedit.iseditable = false;
    this.fmclienteedit.clientedirecciones = [];
    this.fmclienteedit.show(() => { this.GetCliente() });
  }
  ShowEditCliente(i) {

    this.fmclienteedit.cliente = null;
    this.fmclienteedit.iseditable = true;
    this.fmclienteedit.cliente = i;
    this.fmclienteedit.show(() => { this.GetCliente() });
  }
  async ShowDeleteCliente(i) {
    this.cliente = i;
    if (this.cliente != undefined) {
      await this.data.AsyncGetFromValue(this.data.api.cliente, 'idcliente', this.cliente.idcliente).then(r => {
        try {
          if (r.idcliente != '' || r.idcliente != undefined) {
            this.data.notify('Estimado(a), ¿Estas seguro de eliminar el cliente seleccionado: [' + this.cliente.documento + ' | ' + this.cliente.apellidos + ']?', 'Eliminar cliente', this.data.alertType.question, new ALertOption(true, true, 'Sí, ELiminar', 'Cerrar'), async (r) => {
              this.data.wait('Espere por favor, estamos eliminando el cliente seleccionado. Gracias', 'Eliminando Cliente');

              await this.data.AsyncDelete(this.data.api.cliente, this.cliente.idcliente).then(r => {
                if (r.status == 'success') {
                  this.data.notify(r.message, 'Cliente eliminado', this.data.alertType.success, new ALertOption());
                  this.GetCliente();
                } else {
                  this.data.notify(r.message, 'Error al eliminar', this.data.alertType.error, new ALertOption());
                }
              }).catch(e => { this.data.notifyClose(); this.data.notify("Error", 'Error al registrar cliente', this.data.alertType.error, new ALertOption()); });
            });
          } else {
            this.data.notify('Estimado(a), el cliente no puede ser eliminado, debido a que está asociado a otros documentos electrónicos.', 'Advertencia', this.data.alertType.warning, new ALertOption());
          }
        } catch (ex) { console.log(ex); }
      });
    }
  }

  GetTiposCliente() {
    this.data.GetSimple('tipocliente').subscribe(
      r => {
        this.tiposclientes = r;
        console.log('Tipos de cliente:', this.tiposclientes);
      },
      e => console.error('Error obteniendo tipos de cliente:', e)
    );
  }

  /**
   * 
   * @param id 
   * Busca en la lista de tiposClientes y extrae el nombre
   */
  getNombreTipoCliente(id:Number){
    const tipo = this.tiposclientes.find((t:any) => t.id === id);
    console.log('Buscando nombre para tipo cliente ID:', id, 'Encontrado:', tipo);
    return tipo ? tipo.descripcion : 'Sin tipo';
  }
}
